import RecurringRegistrationsService from "@/services/RecurringRegistrationsService";

const getDefaultState = () => {
    return {
        recRegistrations: [],
    };
};

export default {
    state: () => getDefaultState(),
    getters: {
        getRecRegistrations: state => state.recRegistrations,
    },
    mutations: {
        setRecRegistrations: (state, recRegistrations) => {
            state.recRegistrations = recRegistrations;
        },
        setRecRegistrationsState: state => {
            Object.assign(state, getDefaultState());
        },
    },
    actions: {
        processRecRegistrations: async ({ dispatch, commit }) => {
            try {
                commit("setLoading", true);
                const response = await RecurringRegistrationsService.get();
                commit("setRecRegistrations", response.data.data);
            } catch (e) {
                if (e.response.data.message === "Objects were not found") {
                    commit("setRecRegistrations", []);
                } else {
                    dispatch("generalErrorHandling", e);
                }
            } finally {
                commit("setLoading", false);
            }
        },

        addRecRegistrations: async ({ dispatch, commit }, recRegistration) => {
            try {
                commit("setLoading", true);
                await RecurringRegistrationsService.create(recRegistration);
                await dispatch("processRecRegistrations");
                commit({
                    type: "alert",
                    text: "New registration saved",
                    color: "success",
                    icon: "save",
                });
            } catch (e) {
                dispatch("generalErrorHandling", e);
            } finally {
                commit("setLoading", false);
            }
        },

        editRecRegistrations: async ({ dispatch, commit }, recRegistration) => {
            try {
                commit("setLoading", true);
                await RecurringRegistrationsService.update(
                    recRegistration.template_id,
                    recRegistration
                );

                await dispatch("processRecRegistrations");
                commit({
                    type: "alert",
                    text: "Registration changes saved",
                    color: "primary",
                    icon: "save",
                });
            } catch (e) {
                dispatch("generalErrorHandling", e);
            } finally {
                commit("setLoading", false);
            }
        },

        deleteRecRegistrations: async ({ dispatch, commit }, id) => {
            try {
                commit("setLoading", true);
                await RecurringRegistrationsService.delete(id);
                await dispatch("processRecRegistrations");
                commit({
                    type: "alert",
                    text: "Registration deleted",
                    color: "error",
                    icon: "delete_sweep",
                });
            } catch (e) {
                dispatch("generalErrorHandling", e);
            } finally {
                commit("setLoading", false);
            }
        },

        resetRecurringRegistrationsState: ({ commit }) => {
            commit("setRecRegistrationsState");
        },
    },
};
